
import {Component, Vue} from "vue-property-decorator";
import RaporAiGecmis from "@/components/rapor/RaporAiGecmis.vue";
import {
  baslikUret,
  gecmisiOku,
  gecmisiTemizle,
  GecmisSohbeti,
  sohbetiKaydet,
  sohbetiSil,
  yeniSohbetKimligi,
} from "@/plugins/raporAiGecmisDeposu";

interface SohbetMesaji {
  rol: "kullanici" | "ai";
  metin?: string;
  /** true: bu mesaj önceki isteğin YERİNE geçer (tam prompt önerisi); false/yok: üstüne EKLENİR */
  yerineGecen?: boolean;
  taslak?: any;
  uyari?: string;
  kaydedildi?: boolean;
  kaynakTaslak?: any;
  cevaplandi?: boolean;
  cevapTaslagi?: string;
  cevap?: string;
}

@Component({components: {RaporAiGecmis}})
export default class RaporAiSihirbazi extends Vue {
  cumle: string = "";
  bekliyor = false;
  sohbet: Array<SohbetMesaji> = [];
  // Soru-cevap turlarında aynı isteğe eklenerek gönderilir
  sonCumle: string = "";
  cevaplar: Array<{ soru: string; cevap: string }> = [];

  hazirOneriler = [
    "Derdest dosyaların takip toplamı, tahsilatı ve kalan bakiyesi",
    "100.000 TL üzeri açık dosyalar",
    "Borçluların telefon numaralarıyla derdest dosya listesi",
    "Haciz konulmuş kambiyo takiplerini borçlu ve tutarıyla listele",
    "Kapalı dosyaları takip türü ve kapanış tarihiyle raporla",
    "Bu yıl açılan dosyaların tahsilat ve masraf toplamı",
  ];

  alanlariGoster: number | null = null;
  guncelSonuc: any = null;
  guncelTaslak: any = null;
  guncelKaydedildi = false;
  guncelZaman: string = "";
  // Panelde sayfa başına 20 satır (ekrandaki satırların tamamı sayfalanarak gezilir)
  ONIZLEME_LIMIT = 20;
  onizlemeSayfa = 1;
  kaydetDialog = false;
  kaydetIsim: string = "";
  // Kalemle düzeltilen mesajın sırası: gönderilince o mesaj ve sonrası yerine yenisi geçer
  duzenlemeIndex: number | null = null;
  // Sohbet geçmişi bu tarayıcıda saklanır (kiracı+kullanıcı bazlı); sunucuya gitmez
  gecmisSohbetleri: Array<GecmisSohbeti> = [];
  gecmisAcik = false;
  aktifSohbetId: string = "";

  mounted() {
    this.gecmisSohbetleri = gecmisiOku();
  }

  /** Katlı haldeyken ilk üç sütunu gösterir: "Kart No, İcra Dairesi, Takip Tarihi +4" */
  alanOnizleme(taslak: any): string {
    const adlar = (taslak.alanlar || []).map((a: any) => a.isim);
    if (!adlar.length) return "";
    const ilk = adlar.slice(0, 3).join(", ");
    return adlar.length > 3 ? ilk + " +" + (adlar.length - 3) : ilk;
  }

  /** Karşılama ekranındaki kısa liste; tamamı çekmecede */
  get sonSohbetler(): Array<GecmisSohbeti> {
    return this.gecmisSohbetleri.slice(0, 4);
  }

  /**
   * Her turdan sonra sohbeti diske yazar. Sonuç SATIRLARI yazılmaz — sohbete
   * dönüldüğünde rapor taslaktan yeniden çalıştırılır (veri bu arada değişmiş olabilir).
   */
  sohbetiSakla() {
    const kullaniciMesaji = this.sohbet.find(m => m.rol === "kullanici" && m.metin);
    if (!kullaniciMesaji) return;
    if (!this.aktifSohbetId) this.aktifSohbetId = yeniSohbetKimligi();
    const mevcut = this.gecmisSohbetleri.find(s => s.id === this.aktifSohbetId);
    const sonTaslakMesaji = this.sonTaslakIndex >= 0 ? this.sohbet[this.sonTaslakIndex] : null;

    this.gecmisSohbetleri = sohbetiKaydet({
      id: this.aktifSohbetId,
      baslik: (mevcut && mevcut.baslik) || baslikUret(kullaniciMesaji.metin || ""),
      olusturma: (mevcut && mevcut.olusturma) || Date.now(),
      guncelleme: Date.now(),
      mesajlar: this.sohbet.map(m => ({
        rol: m.rol, metin: m.metin, yerineGecen: m.yerineGecen, taslak: m.taslak,
      })),
      sonTaslak: sonTaslakMesaji ? sonTaslakMesaji.taslak : null,
      kayitliRaporAdi: (mevcut && mevcut.kayitliRaporAdi) || undefined,
    });
  }

  /** Geçmişten sohbete dönüş: mesajlar ve taslak geri gelir, sonuç paneli boş başlar */
  sohbetiYukle(gecmis: GecmisSohbeti) {
    this.gecmisAcik = false;
    this.aktifSohbetId = gecmis.id;
    this.sohbet = (gecmis.mesajlar || []).map(m => ({
      rol: m.rol, metin: m.metin, yerineGecen: m.yerineGecen, taslak: m.taslak,
    })) as any;
    this.cumle = "";
    this.cevaplar = [];
    this.duzenlemeIndex = null;
    this.sonCumle = this.birikmisIstek;
    this.guncelSonuc = null;
    this.guncelTaslak = null;
    this.guncelKaydedildi = false;
    this.guncelZaman = "";
    this.enAltaKay();
  }

  /** Sohbet rapora dönüştüyse geçmişte işaretlenir; id varsa oradan rapora atlanır */
  kayitliRaporuIsaretle(isim: string, raporId?: number) {
    if (!this.aktifSohbetId) return;
    const mevcut = this.gecmisSohbetleri.find(s => s.id === this.aktifSohbetId);
    if (!mevcut) return;
    this.gecmisSohbetleri = sohbetiKaydet({
      ...mevcut,
      kayitliRaporAdi: isim,
      kayitliRaporId: raporId,
      guncelleme: Date.now(),
    });
  }

  gecmistenSil(gecmis: GecmisSohbeti) {
    this.gecmisSohbetleri = sohbetiSil(gecmis.id);
    if (this.aktifSohbetId === gecmis.id) this.aktifSohbetId = "";
  }

  gecmisiSil() {
    this.gecmisSohbetleri = gecmisiTemizle();
    this.aktifSohbetId = "";
  }

  // Yanlış kurulmuş koşulu cümleyi baştan yazmadan at (özet ile gerçek koşul birlikte gider)
  kosuluKaldir(taslak: any, index: number) {
    taslak.kosul_ozeti.splice(index, 1);
    taslak.rapor_secilen_kosullar.kosullar.splice(index, 1);
  }

  // Sohbet güncellenince en alta kay (klasik sohbet davranışı)
  enAltaKay() {
    this.$nextTick(() => {
      const alan = this.$refs.sohbetAlani as HTMLElement;
      if (alan) alan.scrollTop = alan.scrollHeight;
    });
  }

  /**
   * Sohbet BİRİKİMLİDİR: her yeni mesaj öncekinin üstüne eklenir, böylece kullanıcı
   * raporu adım adım daraltır. Tam prompt önerisi (yerineGecen) geldiğinde birikim
   * oradan yeniden başlar — öneri zaten önceki isteğin tamamını içeriyor.
   */
  get birikmisIstek(): string {
    const parcalar: Array<string> = [];
    this.sohbet.forEach(mesaj => {
      if (mesaj.rol !== "kullanici" || !mesaj.metin) return;
      if (mesaj.yerineGecen) parcalar.length = 0;
      parcalar.push(mesaj.metin.trim());
    });
    return parcalar.join(". ");
  }

  /** Panelin altındaki tek tıklık daraltmalar: kısa "şunu da ekle" ifadeleri */
  get daraltmaOnerileri(): Array<string> {
    const taslak = this.guncelTaslak;
    if (!taslak || !taslak.oneriler) return [];
    return taslak.oneriler.slice(0, 4);
  }

  get sayfaSayisi(): number {
    if (!this.guncelSonuc) return 1;
    return Math.max(1, Math.ceil(this.guncelSonuc.satirlar.length / this.ONIZLEME_LIMIT));
  }

  get gorunenSatirlar(): Array<any> {
    if (!this.guncelSonuc) return [];
    const bas = (this.onizlemeSayfa - 1) * this.ONIZLEME_LIMIT;
    return this.guncelSonuc.satirlar.slice(bas, bas + this.ONIZLEME_LIMIT);
  }

  get satirAraligi(): string {
    if (!this.guncelSonuc) return "";
    const bas = (this.onizlemeSayfa - 1) * this.ONIZLEME_LIMIT;
    return (bas + 1) + "–" + Math.min(bas + this.ONIZLEME_LIMIT, this.guncelSonuc.satirlar.length);
  }

  get sonTaslakIndex(): number {
    for (let i = this.sohbet.length - 1; i >= 0; i--) {
      if (this.sohbet[i].taslak) return i;
    }
    return -1;
  }

  // Koşul rozetinde ham enum yerine okunur karşılık (acik -> Açık/Derdest)
  kosulDegerEtiketi(kosul: any): string {
    const etiketler: { [k: string]: string } = {
      acik: "Açık (Derdest)", kapali: "Kapalı (Hitam)", acilmamis: "Açılmamış",
      avukat: "Haricen Avukata", muvekkil: "Haricen Müvekkile", icra: "İcraya",
      banka: "Bankaya", ptt: "PTT'ye",
      gonderildi: "Gönderildi", teblig_edildi: "Tebliğ Edildi", bila_oldu: "Bila Oldu",
    };
    return etiketler[kosul.deger] || kosul.deger;
  }

  operatorEtiket(op: string): string {
    const etiketler: { [k: string]: string } = {
      esittir: "=", buyuktur: ">", kucuktur: "<",
      buyuk_esittir: "≥", kucuk_esittir: "≤", icerir: "içerir", icermez: "içermez",
    };
    return etiketler[op] || op;
  }

  taslakIste(cevaplarla: boolean = false) {
    const metin = this.cumle.trim();
    if (!cevaplarla) {
      if (!metin) return;
      // Kalemle düzeltme: düzeltilen mesaj ve sonrası atılır, yerine yenisi yazılır
      if (this.duzenlemeIndex !== null) {
        this.sohbet.splice(this.duzenlemeIndex);
        this.duzenlemeIndex = null;
      }
      this.cevaplar = [];
      this.sohbet.push({rol: "kullanici", metin});
      this.sonCumle = this.birikmisIstek;
      this.enAltaKay();
    }
    this.bekliyor = true;
    this.$http.post("/api/v1/rapor-ai/taslak", {
      cumle: this.sonCumle,
      cevaplar: this.cevaplar,
    }).then((response: any) => {
      const taslak = response.data;
      this.alanlariGoster = null;
      this.sohbet.push({rol: "ai", taslak});
      this.sohbetiSakla();
      (taslak.sorular || []).forEach((soru: string) => {
        this.sohbet.push({rol: "ai", metin: soru, cevaplandi: false, cevapTaslagi: ""});
      });
      this.cumle = "";
      this.enAltaKay();
    }).finally(() => {
      this.bekliyor = false;
    });
  }

  /**
   * Öneri balonuna tıklamak DOĞRUDAN gönderir (31.08 kullanıcı kararı: tıkla-sonra-Enter
   * fazlalıktı). Yanlış gidersek geri dönüş yolu mesajın yanındaki kalemdir.
   * yerineGecen=true: tam prompt önerisi (isteğin tamamını içerir) — birikimi sıfırlar.
   * yerineGecen=false: kısa daraltma ("kalan bakiye ile birlikte") — isteğin üstüne eklenir.
   */
  oneriyiGonder(oneri: string, yerineGecen: boolean) {
    if (this.bekliyor) return;
    this.duzenlemeIndex = null;
    this.cevaplar = [];
    this.sohbet.push({rol: "kullanici", metin: oneri, yerineGecen});
    this.sonCumle = this.birikmisIstek;
    this.cumle = "";
    this.enAltaKay();
    this.taslakIste(true);
  }

  // Kalem: mesajı input'a geri getirir; gönderilince o noktadan sonrası yeniden kurulur
  mesajiDuzenle(index: number) {
    this.duzenlemeIndex = index;
    this.cumle = this.sohbet[index].metin || "";
    this.$nextTick(() => {
      const alan = this.$el.querySelector("textarea") as HTMLTextAreaElement;
      if (alan) alan.focus();
    });
  }

  duzenlemedenVazgec() {
    if (this.duzenlemeIndex === null) return;
    this.duzenlemeIndex = null;
    this.cumle = "";
  }

  raporuGetir(taslak: any) {
    this.bekliyor = true;
    this.$http.post("/api/v1/rapor-ai/calistir", {
      rapor_alanlari: taslak.rapor_alanlari,
      rapor_secilen_kosullar: taslak.rapor_secilen_kosullar,
    }).then((response: any) => {
      const sonuc = response.data;
      if (sonuc.durum === "cok_buyuk") {
        this.sohbet.push({rol: "ai", uyari: sonuc.mesaj, kaynakTaslak: taslak});
      } else {
        // Aynı panel güncellenir: nihai sonuca sohbetle yaklaşma akışı
        this.guncelSonuc = sonuc;
        this.guncelTaslak = taslak;
        this.guncelKaydedildi = false;
        this.onizlemeSayfa = 1;
        // Her getirmede sohbete yeni satır eklemek yerine paneldeki damga tazelenir
        this.guncelZaman = new Date().toLocaleTimeString("tr-TR",
            {hour: "2-digit", minute: "2-digit"});
        this.panelegit();
      }
      this.enAltaKay();
    }).finally(() => { this.bekliyor = false; });
  }

  // Raporu Getir sonrası kullanıcıyı sonucun başına indir
  panelegit() {
    this.$nextTick(() => {
      const panel: any = this.$refs.guncelPanel;
      const el = panel && panel.$el ? panel.$el : panel;
      if (el && el.scrollIntoView) {
        el.scrollIntoView({behavior: "smooth", block: "start"});
      }
    });
  }

  // Ad kullanıcıdan alınır; AI'ın ürettiği ad yalnız ön dolgudur
  kaydetDialogAc() {
    this.kaydetIsim = (this.guncelTaslak && this.guncelTaslak.isim) || "";
    this.kaydetDialog = true;
  }

  kaydetOnayla() {
    const isim = this.kaydetIsim.trim();
    if (!isim) return;
    const taslak = this.guncelTaslak;
    this.bekliyor = true;
    this.$http.post("/api/v1/rapor", {
      isim,
      kategori: "AI",
      rapor_alanlari: taslak.rapor_alanlari,
      rapor_secilen_kosullar: taslak.rapor_secilen_kosullar,
    }).then((response: any) => {
      this.guncelKaydedildi = true;
      this.kaydetDialog = false;
      this.kayitliRaporuIsaretle(isim, response && response.data ? response.data.id : undefined);
      this.$emit("rapor-kaydedildi");
    }).finally(() => { this.bekliyor = false; });
  }

  yeniSohbet() {
    this.sohbet = [];
    this.cumle = "";
    this.sonCumle = "";
    this.cevaplar = [];
    this.duzenlemeIndex = null;
    this.alanlariGoster = null;
    this.guncelSonuc = null;
    this.guncelTaslak = null;
    this.guncelKaydedildi = false;
    this.guncelZaman = "";
    this.onizlemeSayfa = 1;
  }

  soruyuCevapla(mesaj: SohbetMesaji) {
    const cevap = (mesaj.cevapTaslagi || "").trim();
    if (!cevap) return;
    mesaj.cevap = cevap;
    mesaj.cevaplandi = true;
    this.cevaplar.push({soru: mesaj.metin || "", cevap});
    // Tüm açık sorular cevaplanınca taslağı yenile
    const acikSoru = this.sohbet.some(m => m.rol === "ai" && m.metin && !m.taslak && !m.cevaplandi);
    if (!acikSoru) this.taslakIste(true);
  }
}
